import { routes } from "routes";

export enum TABS {
  home = "/",
  explore = "/explore",
  add = "/create",
  saved = "/saved",
  profile = "/profile",
  categories = "/categories",
}

export const getTabStatus = (path: string, username: string | null): {[key: string]: boolean | null | string} => ({
  [TABS.home]: path === routes.home(),
  [TABS.explore]: [
    routes.explore(),
    routes.exploreCreators(),
    routes.exploreImages(),
    routes.niches(),
    routes.exploreTop(),
  ].includes(path),
  [TABS.add]: path === routes.create(),
  [TABS.saved]: username && (path === routes.userCollections(username) || path.startsWith(`${routes.userCollections(username)}/`)),
  [TABS.categories]: path.includes(routes.trendingTags()),
  [TABS.profile]: username && path === routes.user(username),
});
